module.exports.colours = {
  "a": "#B0BF1A",
  "b": "#7CB9E8",
  "c": "#B284BE",
  "d": "#72A0C1",
  "e": "#F19CBB",
  "f": "#C46210",
  "g": "#3B7A57",
  "h": "#8DB600",
  "i": "#89CFF0",
  "j": "#CD7F32",
  "k": "#88540B",
  "l": "#CC5500",
  "m": "#5F9EA0",
  "n": "#0D98BA",
  "o": "#DE5D83",
  "p": "#CB4154",
  "q": "#FB607F",
  "r": "#8C92AC",
  "s": "#B87333",
  "t": "#008B8B",
  "u": "#B8860B",
  "v": "#FF8C00",
  "w": "#B94E48",
  "x": "#1E90FF",
  "y": "#C2B280",
  "z": "#BF00FF",
}

module.exports.funcColours = {
  "tax": "#B0BF1A",
  "n/a": "#B94E48",
  "advisory": "#B284BE",
  "audit": "#F19CBB",
}